var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal_password","size":"md","title":"Acceso / Login","hide-header":"","ok-only":"","content-class":"shadow","button-size":"sm","centered":"","ok-title":"Cancelar","ok-variant":"outline-secondary"}},[_c('password')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }